module.exports = __webpack_public_path__ + "assets/img/c488-gb-wls.svg";